// extracted by mini-css-extract-plugin
module.exports = {"content":"Footer_content__1MZyl","copyRight":"Footer_copyRight__30Mnf","icon":"Footer_icon__1HZM_"};